import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { useLoading } from '../../../shared-components/utils/hooks/use-loading';
import { Spinner } from '../../../shared-components/decorators/spinner';

import { Tooltip, getTooltipData } from '../../../elements-tooltip/tooltip';

export const InvoiceCard = ({
  invoiceId,
  month,
  year,
  day,
  country,
  feeName,
  title,
  onDownloadClick,
  isTransactional,
  isHost
}) => {
  const { asyncFn: handleDownloadClick, isLoading: isDownloading } = useLoading(onDownloadClick);

  const fullDateLine = `${month}${day ? ` ${day}` : ''}, ${year}`;

  return <div className="InvoiceCard padding-lg full-width border">
    <div className="flex space-between">
      <div className="heavier">
        {isTransactional
          ? `#${invoiceId}`
          : <div className="flex middle" style={{ gap: 4 }}>
            <FormattedMessage
              id="hosting.tax_details_page.monthly_invoice"
              defaultMessage="Monthly Invoice: {date}"
              values={{
                date: `${month} ${year}`
              }}
            />
            <Tooltip tooltip={getTooltipData().TAX_INVOICES(isHost)} />
          </div>
        }
      </div>
      <button className="btn-clear download-button" type="button" disabled={isDownloading} onClick={handleDownloadClick}>
        {isDownloading ?
          <Spinner additionalStyle="gray" /> :
          <img className="icon" src="https://assets.peerspace.com/download-arrow-icon.svg?v=rb" alt="download" />
        }
      </button>
    </div>
    <hr className="margin-lg-top margin-md-bottom" />
    <div className="text-gray-600 flex" style={{ gap: 4 }}>
      {isTransactional && <>
        <span className="heavier">
          {fullDateLine}
        </span>
        <span className="dot-divider" />
      </>}
      <span>{country}</span>
      <span>{feeName}</span>
    </div>
    {isTransactional && title &&
    <div className="text-gray-600 margin-sm-top ellipsis">
      {title}
    </div>}
  </div>;
};

InvoiceCard.propTypes = {
  invoiceId: PropTypes.string,
  month: PropTypes.object,
  day: PropTypes.object,
  year: PropTypes.string,
  country: PropTypes.string,
  feeName: PropTypes.string,
  title: PropTypes.string,
  isTransactional: PropTypes.bool,
  onDownloadClick: PropTypes.func,
  isHost: PropTypes.bool
};
